module.exports = __webpack_public_path__ + "img/Mardona-5.e58d6db7.webp";